import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, Home, Users, GraduationCap, FileText, Image as ImageIcon, Newspaper } from "lucide-react";

export default function AdminNav({ user, active }) {
  // active: "santri" | "pembimbing"
  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-parchment/85 backdrop-blur-md border-b border-gold/30">
      <nav className="max-w-[1600px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 flex-shrink-0" data-testid="dash-brand">
          <img
            src="https://customer-assets.emergentagent.com/job_generasi-flow/artifacts/fgw1jyfc_LOGO%20PONDOK%20GRQ%202022_alter.png"
            alt="Logo GRQ" className="h-11 w-11 object-contain"
          />
          <div className="leading-tight hidden sm:block">
            <div className="text-[10px] tracking-[0.25em] uppercase text-moss">Portal Admin</div>
            <div className="font-serif-display text-forest text-base">Generasi Rabbani Qurani</div>
          </div>
        </Link>

        {/* Section tabs */}
        <div className="hidden md:flex items-center gap-1 rounded-full bg-sand p-1 border border-gold/20">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs transition-colors ${
                isActive || active === "santri"
                  ? "bg-forest text-parchment"
                  : "text-forest hover:bg-white"
              }`
            }
            data-testid="admin-nav-santri"
          >
            <GraduationCap size={14} /> Santri
          </NavLink>
          <NavLink
            to="/admin/pembimbing"
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs transition-colors ${
                isActive || active === "pembimbing"
                  ? "bg-forest text-parchment"
                  : "text-forest hover:bg-white"
              }`
            }
            data-testid="admin-nav-pembimbing"
          >
            <Users size={14} /> Pembimbing
          </NavLink>
          <NavLink
            to="/admin/perizinan"
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs transition-colors ${
                isActive || active === "perizinan"
                  ? "bg-forest text-parchment"
                  : "text-forest hover:bg-white"
              }`
            }
            data-testid="admin-nav-perizinan"
          >
            <FileText size={14} /> Perizinan
          </NavLink>
          <NavLink
            to="/admin/galeri"
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs transition-colors ${
                isActive || active === "galeri"
                  ? "bg-forest text-parchment"
                  : "text-forest hover:bg-white"
              }`
            }
            data-testid="admin-nav-galeri"
          >
            <ImageIcon size={14} /> Galeri
          </NavLink>
          <NavLink
            to="/admin/artikel"
            className={({ isActive }) =>
              `inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs transition-colors ${
                isActive || active === "artikel"
                  ? "bg-forest text-parchment"
                  : "text-forest hover:bg-white"
              }`
            }
            data-testid="admin-nav-artikel"
          >
            <Newspaper size={14} /> Artikel
          </NavLink>
        </div>

        <div className="flex items-center gap-3">
          <span className="hidden lg:inline text-xs text-moss">
            <span className="tracking-[0.2em] uppercase">Masuk sebagai</span>{" "}
            <span className="text-forest font-medium">{user?.name}</span>
          </span>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gold/40 text-forest text-xs hover:bg-gold hover:text-forest transition-colors"
            data-testid="dash-home"
          >
            <Home size={14} /> Beranda
          </Link>
          <LogoutBtn />
        </div>
      </nav>

      {/* Mobile tabs */}
      <div className="md:hidden flex items-center gap-1 px-4 pb-3">
        <NavLink
          to="/admin" end
          className={({ isActive }) =>
            `flex-1 text-center px-3 py-1.5 rounded-full text-xs ${
              isActive || active === "santri"
                ? "bg-forest text-parchment"
                : "bg-sand text-forest"
            }`
          }
        >
          Santri
        </NavLink>
        <NavLink
          to="/admin/pembimbing"
          className={({ isActive }) =>
            `flex-1 text-center px-3 py-1.5 rounded-full text-xs ${
              isActive || active === "pembimbing"
                ? "bg-forest text-parchment"
                : "bg-sand text-forest"
            }`
          }
        >
          Pembimbing
        </NavLink>
        <NavLink
          to="/admin/perizinan"
          className={({ isActive }) =>
            `flex-1 text-center px-3 py-1.5 rounded-full text-xs ${
              isActive || active === "perizinan"
                ? "bg-forest text-parchment"
                : "bg-sand text-forest"
            }`
          }
        >
          Perizinan
        </NavLink>
        <NavLink
          to="/admin/galeri"
          className={({ isActive }) =>
            `flex-1 text-center px-3 py-1.5 rounded-full text-xs ${
              isActive || active === "galeri"
                ? "bg-forest text-parchment"
                : "bg-sand text-forest"
            }`
          }
        >
          Galeri
        </NavLink>
        <NavLink
          to="/admin/artikel"
          className={({ isActive }) =>
            `flex-1 text-center px-3 py-1.5 rounded-full text-xs ${
              isActive || active === "artikel"
                ? "bg-forest text-parchment"
                : "bg-sand text-forest"
            }`
          }
        >
          Artikel
        </NavLink>
      </div>
    </header>
  );
}

function LogoutBtn() {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        localStorage.removeItem("grq_token");
        window.location.href = "/";
      }}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-forest text-parchment text-xs hover:bg-gold transition-colors"
      data-testid="dash-logout"
    >
      <LogOut size={14} /> Keluar
    </button>
  );
}
